import { combineReducers, configureStore } from "@reduxjs/toolkit"
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist"

import { initialBehaviorTable } from "~/store/behavior-table/BehaviorTable"
import { initialBOLState } from "~/features/bol/state"
import { initialCargoState } from "~/features/cargo/state"
import { combinedReducers } from "~/store/PersistConfig"
import { initialUserState } from "~/store/user/userSlice"
import { initialCargoOwnerState } from "~/features/cargo-owners/model/state"

const appReducer = combineReducers({
  ...combinedReducers,
})
type TState = {
  cargo: any
  auth: any
  user: any
  common: any
  behaviorTable: any
  bolManagement: any
  contractManagement: any
  cargoOwners: any
}
const rootReducer = (state: any, action: any): Partial<TState> => {
  //solution 1st
  if (action.type === "logout") {
    //return appReducer(undefined, action)
    //Clear all reducers except the common reducer
    const commonStateValue = localStorage.getItem("persist:common")
    localStorage.clear()
    localStorage.setItem("persist:common", commonStateValue!)
    window.location.reload()
    return {
      common: state.common, // Preserve the common reducer
      user: initialUserState,
      behaviorTable: initialBehaviorTable,
      bolManagement: initialBOLState,
      cargo: initialCargoState,
      cargoOwners: initialCargoOwnerState,
    }
  }

  //solution 2nd
  // if (action.type === "RESET_STATE") {
  //   // Reset all reducers except 'common' to their initial state
  //   const { common } = state
  //   const commonStateValue = localStorage.getItem("persist:common")
  //   localStorage.clear()
  //   localStorage.setItem("persist:common", commonStateValue!)
  //   return {
  //     ...appReducer(undefined, {}),
  //     common, // Preserve the common reducer
  //   }
  // }
  return appReducer(state, action)
}

export const store = configureStore({
  reducer: rootReducer,
  // devTools: process.env.NODE_ENV !== "production",
  devTools: !import.meta.env.PROD,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
